import React from 'react';
import { ArrowRight } from 'lucide-react';
import SERVICES from './servicesData';

// Updated Service Card Component to use the inputLabel and outputLabel from SERVICES data
const ServiceCard = ({ icon, title, description, color, inputLabel, outputLabel }) => {
    return (
        <div className="group relative overflow-hidden rounded-xl transition-all duration-300 hover:translate-y-[-8px]">
            <div className="absolute inset-0 bg-gradient-to-b from-slate-800/90 to-slate-900/90 backdrop-blur-sm shadow-lg" />
            <div className="absolute inset-0 opacity-0 group-hover:opacity-100 bg-gradient-to-r from-blue-600/20 via-purple-600/20 to-blue-600/20 transition-opacity duration-500" />
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-blue-500 to-purple-500 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300" />

            {/* Pipeline connector on left side */}
            <div className="absolute left-0 top-1/2 transform -translate-y-1/2 -translate-x-1/2 w-6 h-20 bg-slate-800 rounded-r-md border border-blue-500/30 overflow-hidden">
                <div className="absolute inset-y-0 right-0 w-1 bg-blue-500/30"></div>
                <div className="absolute top-1/2 left-0 w-2 h-2 bg-blue-400 rounded-full animate-pulse"></div>
            </div>

            <div className="relative p-6 flex flex-col items-center text-center h-full">
                {/* No glow on icons */}
                <div className="bg-gradient-to-tr from-slate-800 to-slate-700 p-3 rounded-lg border border-slate-600/30 mb-4">
                    {icon}
                </div>
                <h3 className="text-xl font-bold text-white mb-3">{title}</h3>
                <p className="text-slate-300 leading-relaxed">{description}</p>

                {/* Data flow indicators with service-specific labels from SERVICES data */}
                <div className="mt-6 w-full">
                    <div className="w-full h-1 bg-slate-700/50 rounded-full overflow-hidden">
                        <div className="h-full bg-gradient-to-r from-blue-500 to-purple-500 w-0 group-hover:w-full transition-all duration-1000 rounded-full"></div>
                    </div>
                    <div className="mt-3 flex justify-between items-center">
                        <div className="flex items-center">
                            <div className="w-2 h-2 bg-blue-400 rounded-full mr-1 animate-pulse"></div>
                            <span className="text-xs text-blue-400">{inputLabel}</span>
                        </div>
                        <div className="flex items-center">
                            <span className="text-xs text-purple-400">{outputLabel}</span>
                            <div className="w-2 h-2 bg-purple-400 rounded-full ml-1 animate-pulse"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const WhatWeDoSection = ({ onNavigate }) => {
    const handleNavigate = (path) => {
        onNavigate(path);
    };

    return (
        <section className="py-20 px-4 relative z-10">
            <div className="max-w-6xl mx-auto">
                <div className="flex flex-col md:flex-row justify-between items-start md:items-end mb-12">
                    <div className="max-w-2xl">
                        <div className="inline-block px-3 py-1 bg-blue-900/30 rounded-full text-blue-400 text-sm font-medium mb-4 border border-blue-700/30">
                            Our Departments
                        </div>
                        <h2 className="text-3xl md:text-4xl font-bold mb-4 bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent">
                            What We Do
                        </h2>
                        <p className="text-lg text-slate-300">
                            We offer comprehensive services across six specialized departments, each focused on maximizing the value of your data and transforming how your business operates.
                        </p>
                    </div>
                    <div className="mt-6 md:mt-0">
                        <button
                            onClick={() => handleNavigate('/assessment')}
                            className="flex items-center text-blue-400 hover:text-blue-300 transition-colors duration-300">
                            <span className="mr-2 font-medium">Explore all departments</span>
                            <ArrowRight className="w-4 h-4" />
                        </button>
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {SERVICES.map((service, index) => (
                        <ServiceCard
                            key={index}
                            icon={service.icon}
                            title={service.title}
                            description={service.description}
                            color={service.color}
                            inputLabel={service.inputLabel}
                            outputLabel={service.outputLabel}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default WhatWeDoSection;